import React, { createContext, useContext, useReducer } from "react";
import axios from "axios";
import Login_reducer from "../reducer/Login_reducer";
import {
  LOGIN_BEGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  REGISTER_BEGIN,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  SET_FORM_STATUS,
} from "../utils/action";
import { ACCEPT_HEADER, login_url, register_url } from "../utils/constant";
import Notification from "../utils/Notification";
const LoginContext = createContext();

const initialState = {
  login_loading: false,
  token: localStorage.getItem("token") || "",
  userinfoData: JSON.parse(localStorage.getItem("userinfo")) || {},
  register_loading: false,
  isLoggedIn: !!localStorage.getItem("token"),
  formStatus: localStorage.getItem("formstatus") === "1",
};

export const LoginProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Login_reducer, initialState);

  const LoginUser = async (formdata) => {
    dispatch({ type: LOGIN_BEGIN });

    try {
      const res = await axios.post(login_url, formdata, {
        headers: { Accept: ACCEPT_HEADER },
      });

      if (res.data.success === 1) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("userinfo", JSON.stringify(res.data.user));
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("formstatus", String(res.data.form_status));

        dispatch({ type: LOGIN_SUCCESS, payload: res.data.user });
        dispatch({ type: SET_FORM_STATUS, payload: res.data.form_status == 1 });

        Notification("success", "Login Successfully");
      } else {
        dispatch({ type: LOGIN_ERROR });
        Notification("error", res.data.message);
      }
      return res.data;
    } catch (err) {
      console.error("login_url err", err);
      dispatch({ type: LOGIN_ERROR });
    }
  };

  const RegisterUser = async (formdata, callback) => {
    dispatch({ type: REGISTER_BEGIN });

    try {
      const res = await axios.post(register_url, formdata, {
        headers: { Accept: ACCEPT_HEADER },
      });

      if (res.data.success === 1) {
        Notification("success", res.data.message);
        dispatch({ type: REGISTER_SUCCESS });
        if (callback) {
          callback();
        }
      } else {
        Notification("error", res.data.message);
        dispatch({ type: REGISTER_ERROR });
      }
    } catch (err) {
      if (err.response?.data?.errors?.email) {
        Notification("error", err.response.data.errors.email[0]);
      } else {
        Notification("error", "Registration Failed");
      }

      dispatch({ type: REGISTER_ERROR });
    }
  };

  const setLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userinfo");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("formstatus");
    localStorage.removeItem("selected_profile");

    dispatch({ type: LOGOUT_USER });
    window.location.href = "/";
  };
  const setFormComplete = () => {
    localStorage.setItem("formstatus", "1");
    dispatch({ type: SET_FORM_STATUS, payload: true });
  };
  return (
    <LoginContext.Provider
      value={{
        ...state,
        LoginUser,
        setLogout,
        RegisterUser,
        setFormComplete,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => useContext(LoginContext);
